<template>
  <div class="container-fluid bg-white container-fluid px-4 py-5 rounded-4 contenedor-principal">
    <h1>{{ $t("comparador.titulo") }}</h1>
    <div class="grid-header">
      <div class="comparaciones-disponibles">
        <span>{{ $t('comparador.comparaciones_disponibles') }}: {{ comparacionesDisponibles }}</span>
      </div>
      <div>
        <DxButton v-bind="{ ...primaryButtonProps(), icon: 'fa-solid fa-plus' }"
          :text="$t('comparador.btn_nueva_comparacion')" @click="nuevaComparacion"
          :disabled="comparacionesDisponibles <= 0">
        </DxButton>
      </div>
    </div>

    <comparaciones-grid ref="gridComparaciones" />
  </div>
</template>

<script setup lang="ts">
import ComparacionesGrid from "@/components/comparaciones/ComparacionesGrid.vue";
import { onMounted, ref } from "vue";
import { useApi } from "@api/integration";
import { DxButton } from "devextreme-vue/button";
import { primaryButtonProps } from "@helpers/button-helper";
import { useModalService } from "@services/modal-service";
import { useIntl } from "@services/i18n";
import { ESAVE_FAILED_TO_PARSE_INVOICE, ESAVE_NO_ENERGY_INFO, AGENT_COMPARISONS_NO_AVAILABLE, ESAVE_NOT_PROCESABLE_INVOICE } from "@/.shared/errors/codes";
import { ApiError } from "@services/http";
import { toastSuccess, toastError } from "@services/notification-service";

const comparacionesDisponibles = ref(0);
const api = useApi();
const modalService = useModalService();
const intl = useIntl();
const gridComparaciones = ref<InstanceType<typeof ComparacionesGrid>>();

const subirFacturaText = `${intl.i18n.t('comparador.subir_factura_title')}`;

onMounted(async () => {
  comparacionesDisponibles.value = (await api.callStandardApi('getCurrentAgentePersonalData', { showLoading: true })).ComparacionesDisponibles;
});

const nuevaComparacion = async () => {

  const ficheroFactura = await modalService.uploadFileBox({ title: intl.i18n.t('comparador.subir_factura_label'), required: true, allowedFileFormats: ['pdf'] }, subirFacturaText);

  if (!!ficheroFactura) {
    try {
      let result = await api.callStandardApi("createComparacionEnergia", { showLoading: true }, ficheroFactura);

      gridComparaciones.value?.verDetalle(result.Id, result.TipoSuministro);
      gridComparaciones.value?.refreshGrid();
      comparacionesDisponibles.value = comparacionesDisponibles.value - 1;
      toastSuccess(intl.i18n.t('comparacionEnergia.messages.creada'));
    }
    catch (e: any) {
      if (e instanceof ApiError && e.details?.errorList.length === 1 && [ESAVE_FAILED_TO_PARSE_INVOICE, AGENT_COMPARISONS_NO_AVAILABLE,
        ESAVE_NO_ENERGY_INFO, ESAVE_NOT_PROCESABLE_INVOICE].includes(e.details.errorList[0].Code))
        toastError(intl.i18n.t(`shared.errors.api.${e.details.errorList[0].Code}`))
      else throw e;
    }
  }
}

</script>
